module.exports = __webpack_public_path__ + "img/info-circle.93dd82a4.svg";